import { useEffect, useState, useCallback } from 'preact/hooks';

declare global {
	interface Window {
		// https://gitlab.seznam.net/rus/login/-/blob/master/src/static/js/api/3.0/src/login.ts
		login?: {
			current?: {
				sbr: boolean;
			};
		};
	}
}

export function useSbr() {
	const [sbr, setSbr] = useState<boolean>(false);

	const sbrSet = useCallback(() => {
		setSbr(window?.login?.current?.sbr ?? false);
	}, [setSbr]);

	useEffect(() => {
		window.addEventListener('badge', sbrSet);
		window.addEventListener('login', sbrSet);
		window.addEventListener('logout', sbrSet);
		window.addEventListener('forget', sbrSet);
		sbrSet();

		return () => {
			window.removeEventListener('badge', sbrSet);
			window.removeEventListener('login', sbrSet);
			window.removeEventListener('logout', sbrSet);
			window.removeEventListener('forget', sbrSet);
		};
	}, []);

	return sbr;
}
